import Hero from "@/components/sections/Hero";
import OpeningsExplorer from "@/components/sections/OpeningsExplorer";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Industries from "@/components/sections/Industries";
import HiringProcess from "@/components/sections/HiringProcess";
import Stats from "@/components/sections/Stats";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import PartnerProgram from "@/components/sections/PartnerProgram";

export default function HomePage() {
  return (
    <>
      <Hero />
      <PartnerProgram />
      <OpeningsExplorer />
      <About />
      <Services />
      <WhyChooseUs />
      <Stats />
      <Industries />
      <HiringProcess />
      <Testimonials />
      <FAQ />
      <Contact />
    </>
  );
}
